// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/sass/style.scss
// module id = 3
// module chunks = 0